import { truncateHtml } from 'shared-widget-components/src/utils/truncateHtml';
import { PackageContentProps } from '../../../models/slides/PackageSlide';

/**
 * PackageTextContent component
 * this component is responsible for rendering the package text content
 * @param packageData - the data of the package
 * @param textColor - the color of the text
 * @param animationClass - the animation class
 * @returns PackageTextContent component
 */

export const PackageTextContent = ({ packageData, textColor, animationClass }: PackageContentProps) => {
  const truncatedDescription = truncateHtml(packageData.description, 120);

  return (
    <>
      <h1
        className='min-[350px]:text-[20px] block overflow-hidden whitespace-normal md:text-[24px] min-[1200px]:text-[28px] font-semibold mb-2 font-body animate-fade'
        style={{
          color: textColor,
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 2,
        }}
      >
        {packageData.title}
      </h1>
      <p className={`min-[350px] font-medium text-[14px] min-[350px]:mb-2 md:mb-5 md:text-[16px] mr-2 w-full font-body ${animationClass}`} style={{ color: textColor }}>
        {truncatedDescription}
      </p>
    </>
  );
};
